<template>
  <div class="login-wrap">
    <div class="login-card">
      <h2>手机租赁竞品价格监控</h2>
      <p class="sub">AppPriceMonitor 登录</p>
      <input v-model.trim="form.username" placeholder="账号" />
      <input v-model.trim="form.password" type="password" placeholder="密码" @keyup.enter="submit" />
      <button @click="submit">登录</button>
    </div>
  </div>
</template>

<script>
import { authLogin } from '@/api/priceMonitor'

export default {
  name: 'LoginPanel',
  data() {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    async submit() {
      if (!this.form.username || !this.form.password) {
        alert('请输入账号和密码')
        return
      }
      const res = await authLogin(this.form)
      if (res.code === 200) {
        const token = res.data.accessToken || ''
        localStorage.setItem('accessToken', token)
        localStorage.setItem('pm_user', JSON.stringify(res.data.user || {}))
        this.$emit('login-success')
      } else {
        alert(res.msg || '登录失败')
      }
    }
  }
}
</script>

<style scoped>
.login-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(120deg, #eff6ff, #f8fafc);
}
.login-card {
  width: 360px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}
h2 {
  margin: 0;
  font-size: 20px;
}
.sub {
  margin: 8px 0 16px;
  color: #6b7280;
}
input, button {
  width: 100%;
  height: 38px;
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 0 12px;
}
button {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
  cursor: pointer;
}
</style>
